import { useDispatch, useSelector } from 'react-redux'
import './TopMenu.scss'
import { type RootState } from '../../Store/Store'
import { MenuItem } from './MenuItem'
import { useLocalization } from '../../Hooks/useLocalization'
import { logout } from '../../Store/AuthenticationSlice'
import { type Language, setActiveLanguage } from '../../Store/InterfaceSlice'

export function TopMenu() {
  const dispatch = useDispatch()
  const localization = useLocalization('top-menu')
  const isLoggedIn = useSelector(
    (state: RootState) => !!state.authentication.user
  )
  const language = useSelector(
    (state: RootState) => state.interface.activeLanguage
  )
  const logOut = () => {
    dispatch(logout())
  }
  const setLanguage = (newLanguage: Language) => {
    dispatch(setActiveLanguage(newLanguage))
  }
  return (
    <div className="top-menu">
      <div className="left-menu">
        <MenuItem
          view={'certificate-list'}
          relatedViews={[
            'certificate-list',
            'certificate-edit',
            'certificate-add',
            'certificate-detail',
          ]}
          localizationText={'Certificaten'}
        />
        <MenuItem
          view={'company-list'}
          relatedViews={[
            'company-list',
            'company-edit',
            'company-add',
            'company-detail',
          ]}
          localizationText={'Ondernemingen'}
        />
        <MenuItem
          view={'certificate-instance-list'}
          relatedViews={[
            'certificate-instance-list',
            'certificate-instance-edit',
            'certificate-instance-add',
            'certificate-instance-detail',
          ]}
          localizationText={'Certificatie instellingen'}
        />
        <MenuItem
          view={'user-list'}
          relatedViews={['user-list', 'user-add', 'user-detail']}
          localizationText={'Gebruikers'}
        />
        <MenuItem
          view={'certificate-type-list'}
          relatedViews={[
            'certificate-type-list',
            'certificate-type-add',
            'certificate-type-edit',
          ]}
          localizationText={'Certificaat types'}
        />
        <MenuItem
          view={'logging-list'}
          relatedViews={['logging-list']}
          localizationText={'Logging'}
        />
        <MenuItem
          view={'reporting'}
          relatedViews={['reporting']}
          localizationText={'Rapportering'}
        />
      </div>
      <div className="right-menu">
        {isLoggedIn ? (
          <div className={`menu-item`} onClick={logOut}>
            {localization.text('logout', 'Logout')}
          </div>
        ) : (
          <MenuItem
            view={'login'}
            relatedViews={['login']}
            localizationText={'Login'}
          />
        )}
        <div className="menu-item language-picker">
          <div
            className={`language-option ${language === 'nl' ? 'active' : ''}`}
            onClick={() => {
              setLanguage('nl')
            }}
          >
            NL
          </div>
          <div
            className={`language-option ${language === 'fr' ? 'active' : ''}`}
            onClick={() => {
              setLanguage('fr')
            }}
          >
            FR
          </div>
          <div
            className={`language-option ${language === 'en' ? 'active' : ''}`}
            onClick={() => {
              setLanguage('en')
            }}
          >
            EN
          </div>
        </div>
      </div>
    </div>
  )
}
